import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export const initialState: any = {
  user: {},
  error: "", // for error message
  loading: false,
  isUserLogout: false,
  errorMsg: false, // for error
};

const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    apiError(state, action: PayloadAction<string>) {
      state.error = action.payload;
      state.loading = true;
      state.isUserLogout = false;
      state.errorMsg = true;
    },
    loginSuccess(state, action: PayloadAction<any>) {
      state.user = action.payload;
      state.loading = false;
      state.errorMsg = false;
    },
    reset_login_flag(state: any) {
      state.error = null;
      state.loading = false;
      state.errorMsg = false;
    },
  },
});

export const { apiError, loginSuccess, reset_login_flag } =
  loginSlice.actions;

export default loginSlice.reducer;
